import React from 'react';

/**
 * The Signa mark - calligraphic "S" in accent color. Used anywhere the PA
 * speaks. `pulse` adds a radial ring animation for active/listening states.
 */

interface SignaGlyphProps {
  size?: number;
  pulse?: boolean;
  color?: string;
}

export function SignaGlyph({ size = 20, pulse = false, color = 'var(--accent)' }: SignaGlyphProps) {
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <svg viewBox="0 0 24 24" width={size} height={size}>
        <path
          d="M6 7 C 6 4.5, 9 4, 12 4 C 15 4, 18 5, 18 7.5 C 18 10, 14 11, 12 12 C 10 13, 6 14, 6 16.5 C 6 19, 9 20, 12 20 C 15 20, 18 19.5, 18 17"
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      {pulse && (
        <span
          style={{
            position: 'absolute',
            inset: -4,
            borderRadius: '50%',
            border: `1.5px solid ${color}`,
            opacity: 0.35,
            animation: 'signa-pulse 1.8s ease-out infinite',
          }}
        />
      )}
    </span>
  );
}
